<script>
    export let text
    export let disabled = false
    export let width = 'auto'
</script>

<style lang="scss">
    .button {
        background: #DF4937;
        border: 1px solid #DF4937;
        border-radius: 30px;
        font-family: Roboto;
        font-size: 17px;
        color: #FFFFFF;
        letter-spacing: 0.05px;
        display: inline-block;
        height: 60px;
        line-height: 60px;
        cursor: pointer;
        padding: 0 35px;
        text-align: center;
        &.disabled {
            opacity: 0.2;
            cursor: default;
        }
        @media screen and (max-width: 600px) {
            width: 100% !important
        }
    }
</style>

<div style="width: {width}" on:click class="button{disabled ? ' disabled' : ''}">
    {text}
</div>
